module.exports = __webpack_public_path__ + "img/dr_wisniewska_r.05fd5710.jpg";